import { hasValue } from "@repo/helpers";
import { useEffect, useMemo, useState } from "react";

import { useRepEnrollmentQuery } from "..";
import GoogleMap from "../../../../components/GoogleMap";
import { GoogleMapReactCoords } from "../../../../components/GoogleMap/types";
import MapSale from "../../../../models/mapSale";
import RecentEnrollmentMarker, { MarkerProps } from "./recentEnrollmentMarker";

interface Props {
	selected: number;
	hovered: number;
	onHover: (id: number) => void;
	onSelect: (id: number) => void;
}

export function RecentEnrollmentsMap(props: Props) {
	const { selected } = props;
	const { data, loaded } = useRepEnrollmentQuery();
	const lastPing = data?.lastMachinePing;
	const [center, setCenter] = useState<GoogleMapReactCoords>({
		lat: 0,
		lng: 0,
	});
	const mapEnrollments = useMemo(() => data?.enrollments?.filter((e) => e.lat && e.lng) ?? [], [data]);

	function setMarker(marker?: MapSale) {
		if (!marker) return;
		setCenter({ lat: marker.lat, lng: marker.lng });
	}

	useEffect(() => {
		if (loaded && mapEnrollments.length) {
			//Initial value when loaded
			const firstMarker = mapEnrollments[0];
			setMarker(firstMarker);
		}
	}, [loaded]);

	useEffect(() => {
		if (!mapEnrollments.length) setMarker();
		if (!hasValue(selected)) setMarker(null);
		else if (selected) {
			const firstMarker = mapEnrollments.filter((v) => v.enrollmentID === selected)[0];
			setMarker(firstMarker);
		} else {
			setMarker(lastPing);
		}
	}, [selected]);

	let items = mapEnrollments;
	if (!items.length) return null;
	if (lastPing) items = items.concat(lastPing);

	return (
		<div style={{ height: "50vh", width: "100%" }}>
			<GoogleMap center={center} initialZoomLevel={7}>
				{items
					.map((v) => {
						return {
							sale: v,
							lat: v.lat,
							lng: v.lng,
							text: v.enrollmentID || "Last Machine Ping",
							active: v.enrollmentID === props.selected,
							hover: v.enrollmentID === props.hovered,
						} as MarkerProps;
					})
					.map((m, i) => (
						<RecentEnrollmentMarker
							key={i}
							{...m}
							onClick={() => props.onSelect(m.sale.enrollmentID)}
							onHover={(active: boolean) => () => props.onHover(active ? m.sale.enrollmentID : null)}
						/>
					))}
			</GoogleMap>
		</div>
	);
}
